// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Page Styles */

.media-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 25px;
}

.page-header h1 {
  margin: 0 0 5px 0;
  color: #fff;
  font-size: 24px;
}

.page-header p {
  margin: 0;
  color: #b9bbbe;
  font-size: 14px;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.stat-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.stat-icon {
  font-size: 28px;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
}

.stat-label {
  color: #72767d;
  font-size: 12px;
  text-transform: uppercase;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #40444b;
  padding-bottom: 10px;
}

.tab {
  background: transparent;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.tab:hover {
  background: #36393f;
  color: #fff;
}

.tab.active {
  background: #5865f2;
  color: #fff;
}

/* Tab Content */
.tab-content {
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Toolbar */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1 1;
}

.filters input,
.filters select {
  padding: 10px 15px;
  border: 1px solid #40444b;
  border-radius: 5px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
  min-width: 150px;
}

.filters input::placeholder {
  color: #72767d;
}

.filters input {
  flex: 1 1;
  max-width: 300px;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-primary {
  background: #5865f2;
  color: #fff;
}

.btn-primary:hover {
  background: #4752c4;
}

.btn-secondary {
  background: #40444b;
  color: #fff;
}

.btn-secondary:hover {
  background: #4f545c;
}

/* Media Grid */
.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}

.media-card {
  background: #2f3136;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.media-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.media-card.inactive {
  opacity: 0.6;
}

.media-preview {
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
  background-color: #36393f;
  position: relative;
}

.media-preview.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #36393f, #2f3136);
}

.media-preview .type-icon {
  font-size: 48px;
  opacity: 0.5;
}

.media-preview .badge {
  position: absolute;
  top: 8px;
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: bold;
}

.media-preview .badge.nsfw {
  right: 8px;
  background: #f04747;
}

.media-preview .badge.premium {
  right: 40px;
  background: #faa61a;
  color: #000;
}

.media-info {
  padding: 12px;
}

.media-info h4 {
  margin: 0 0 8px 0;
  color: #fff;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.media-meta {
  display: flex;
  gap: 12px;
  color: #72767d;
  font-size: 12px;
  margin-bottom: 8px;
}

.media-stats {
  display: flex;
  gap: 12px;
  color: #72767d;
  font-size: 12px;
}

.media-actions {
  display: flex;
  gap: 5px;
  padding: 10px 12px;
  background: #36393f;
  border-top: 1px solid #40444b;
}

.media-actions button {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: background 0.2s;
}

.media-actions button:hover {
  background: #40444b;
}

/* Collections List */
.collections-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.collection-card {
  background: #2f3136;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.collection-card.inactive {
  opacity: 0.6;
}

.collection-cover {
  height: 120px;
  background-size: cover;
  background-position: center;
  background-color: linear-gradient(135deg, #5865f2, #7289da);
}

.collection-info {
  padding: 15px;
  flex: 1 1;
}

.collection-info h4 {
  margin: 0 0 8px 0;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.collection-info p {
  margin: 0 0 12px 0;
  color: #b9bbbe;
  font-size: 13px;
}

.collection-meta {
  display: flex;
  gap: 15px;
  color: #72767d;
  font-size: 13px;
}

.collection-meta .discount {
  color: #43b581;
  font-weight: bold;
}

.collection-actions {
  display: flex;
  gap: 5px;
  padding: 10px 15px;
  background: #36393f;
  border-top: 1px solid #40444b;
}

.collection-actions button {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: background 0.2s;
}

.collection-actions button:hover {
  background: #40444b;
}

/* Categories List */
.categories-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.category-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.category-icon {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.category-info {
  flex: 1 1;
}

.category-info h4 {
  margin: 0 0 4px 0;
  color: #fff;
  font-size: 15px;
}

.category-info p {
  margin: 0;
  color: #72767d;
  font-size: 12px;
}

.category-meta {
  color: #5865f2;
  font-size: 12px;
  margin-top: 4px;
}

.category-actions {
  display: flex;
  gap: 5px;
}

.category-actions button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: background 0.2s;
}

.category-actions button:hover {
  background: #40444b;
}

/* Badges */
.badge {
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 600;
}

.badge.premium {
  background: #faa61a;
  color: #000;
}

.badge.nsfw {
  background: #f04747;
  color: #fff;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #72767d;
}

.empty-state span {
  font-size: 48px;
  display: block;
  margin-bottom: 15px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0 0 20px 0;
  font-size: 16px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #40444b;
}

.modal-header h3 {
  margin: 0;
  color: #fff;
  font-size: 18px;
}

.close-btn {
  background: transparent;
  border: none;
  color: #72767d;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.close-btn:hover {
  color: #fff;
}

.modal form {
  padding: 20px;
}

/* Upload Section */
.upload-section {
  margin-bottom: 15px;
}

.upload-area {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: #2f3136;
  border-radius: 8px;
  border: 2px dashed #40444b;
}

.upload-btn {
  white-space: nowrap;
}

.upload-progress {
  flex: 1 1;
  min-width: 150px;
  height: 20px;
  background: #40444b;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.upload-progress .progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #5865f2, #7289da);
  transition: width 0.3s ease;
}

.upload-progress span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 11px;
  color: #fff;
  font-weight: bold;
}

.file-preview {
  color: #43b581;
  font-size: 13px;
}

.thumbnail-preview {
  margin-top: 10px;
}

.thumbnail-preview img {
  max-width: 150px;
  max-height: 100px;
  border-radius: 4px;
  object-fit: cover;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-group input[type="color"] {
  padding: 5px;
  height: 40px;
  cursor: pointer;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-row.checkboxes {
  display: flex;
  gap: 20px;
}

.form-row.checkboxes label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b9bbbe;
  cursor: pointer;
}

.form-row.checkboxes input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Media Selector */
.media-selector {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
}

.media-select-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
  color: #b9bbbe;
}

.media-select-item:hover {
  background: #40444b;
}

.media-select-item.selected {
  background: #5865f2;
  color: #fff;
}

.media-select-item .check {
  width: 20px;
  font-weight: bold;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #40444b;
  margin-top: 10px;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
  .media-page {
    padding: 15px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .filters {
    flex-direction: column;
  }

  .filters input,
  .filters select {
    width: 100%;
    max-width: none;
  }

  .media-grid {
    grid-template-columns: 1fr;
  }

  .collections-list {
    grid-template-columns: 1fr;
  }

  .categories-list {
    grid-template-columns: 1fr;
  }

  .tabs {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Media.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,SAAO;AACT;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Media Page Styles */\n\n.media-page {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 25px;\n}\n\n.page-header h1 {\n  margin: 0 0 5px 0;\n  color: #fff;\n  font-size: 24px;\n}\n\n.page-header p {\n  margin: 0;\n  color: #b9bbbe;\n  font-size: 14px;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 15px;\n  margin-bottom: 25px;\n}\n\n.stat-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.stat-icon {\n  font-size: 28px;\n}\n\n.stat-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-value {\n  font-size: 22px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.stat-label {\n  color: #72767d;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #40444b;\n  padding-bottom: 10px;\n}\n\n.tab {\n  background: transparent;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.tab:hover {\n  background: #36393f;\n  color: #fff;\n}\n\n.tab.active {\n  background: #5865f2;\n  color: #fff;\n}\n\n/* Tab Content */\n.tab-content {\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Toolbar */\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.filters {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex: 1;\n}\n\n.filters input,\n.filters select {\n  padding: 10px 15px;\n  border: 1px solid #40444b;\n  border-radius: 5px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n  min-width: 150px;\n}\n\n.filters input::placeholder {\n  color: #72767d;\n}\n\n.filters input {\n  flex: 1;\n  max-width: 300px;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.btn-primary {\n  background: #5865f2;\n  color: #fff;\n}\n\n.btn-primary:hover {\n  background: #4752c4;\n}\n\n.btn-secondary {\n  background: #40444b;\n  color: #fff;\n}\n\n.btn-secondary:hover {\n  background: #4f545c;\n}\n\n/* Media Grid */\n.media-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 20px;\n}\n\n.media-card {\n  background: #2f3136;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.media-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.media-card.inactive {\n  opacity: 0.6;\n}\n\n.media-preview {\n  width: 100%;\n  height: 150px;\n  background-size: cover;\n  background-position: center;\n  background-color: #36393f;\n  position: relative;\n}\n\n.media-preview.placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #36393f, #2f3136);\n}\n\n.media-preview .type-icon {\n  font-size: 48px;\n  opacity: 0.5;\n}\n\n.media-preview .badge {\n  position: absolute;\n  top: 8px;\n  padding: 3px 8px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.media-preview .badge.nsfw {\n  right: 8px;\n  background: #f04747;\n}\n\n.media-preview .badge.premium {\n  right: 40px;\n  background: #faa61a;\n  color: #000;\n}\n\n.media-info {\n  padding: 12px;\n}\n\n.media-info h4 {\n  margin: 0 0 8px 0;\n  color: #fff;\n  font-size: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.media-meta {\n  display: flex;\n  gap: 12px;\n  color: #72767d;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.media-stats {\n  display: flex;\n  gap: 12px;\n  color: #72767d;\n  font-size: 12px;\n}\n\n.media-actions {\n  display: flex;\n  gap: 5px;\n  padding: 10px 12px;\n  background: #36393f;\n  border-top: 1px solid #40444b;\n}\n\n.media-actions button {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.media-actions button:hover {\n  background: #40444b;\n}\n\n/* Collections List */\n.collections-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.collection-card {\n  background: #2f3136;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.collection-card.inactive {\n  opacity: 0.6;\n}\n\n.collection-cover {\n  height: 120px;\n  background-size: cover;\n  background-position: center;\n  background-color: linear-gradient(135deg, #5865f2, #7289da);\n}\n\n.collection-info {\n  padding: 15px;\n  flex: 1;\n}\n\n.collection-info h4 {\n  margin: 0 0 8px 0;\n  color: #fff;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.collection-info p {\n  margin: 0 0 12px 0;\n  color: #b9bbbe;\n  font-size: 13px;\n}\n\n.collection-meta {\n  display: flex;\n  gap: 15px;\n  color: #72767d;\n  font-size: 13px;\n}\n\n.collection-meta .discount {\n  color: #43b581;\n  font-weight: bold;\n}\n\n.collection-actions {\n  display: flex;\n  gap: 5px;\n  padding: 10px 15px;\n  background: #36393f;\n  border-top: 1px solid #40444b;\n}\n\n.collection-actions button {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.collection-actions button:hover {\n  background: #40444b;\n}\n\n/* Categories List */\n.categories-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.category-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.category-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n\n.category-info {\n  flex: 1;\n}\n\n.category-info h4 {\n  margin: 0 0 4px 0;\n  color: #fff;\n  font-size: 15px;\n}\n\n.category-info p {\n  margin: 0;\n  color: #72767d;\n  font-size: 12px;\n}\n\n.category-meta {\n  color: #5865f2;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.category-actions {\n  display: flex;\n  gap: 5px;\n}\n\n.category-actions button {\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.category-actions button:hover {\n  background: #40444b;\n}\n\n/* Badges */\n.badge {\n  padding: 3px 8px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.badge.premium {\n  background: #faa61a;\n  color: #000;\n}\n\n.badge.nsfw {\n  background: #f04747;\n  color: #fff;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #72767d;\n}\n\n.empty-state span {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 15px;\n  opacity: 0.5;\n}\n\n.empty-state p {\n  margin: 0 0 20px 0;\n  font-size: 16px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #40444b;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #fff;\n  font-size: 18px;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  color: #72767d;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.close-btn:hover {\n  color: #fff;\n}\n\n.modal form {\n  padding: 20px;\n}\n\n/* Upload Section */\n.upload-section {\n  margin-bottom: 15px;\n}\n\n.upload-area {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 15px;\n  padding: 15px;\n  background: #2f3136;\n  border-radius: 8px;\n  border: 2px dashed #40444b;\n}\n\n.upload-btn {\n  white-space: nowrap;\n}\n\n.upload-progress {\n  flex: 1;\n  min-width: 150px;\n  height: 20px;\n  background: #40444b;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.upload-progress .progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #5865f2, #7289da);\n  transition: width 0.3s ease;\n}\n\n.upload-progress span {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 11px;\n  color: #fff;\n  font-weight: bold;\n}\n\n.file-preview {\n  color: #43b581;\n  font-size: 13px;\n}\n\n.thumbnail-preview {\n  margin-top: 10px;\n}\n\n.thumbnail-preview img {\n  max-width: 150px;\n  max-height: 100px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-group input[type=\"color\"] {\n  padding: 5px;\n  height: 40px;\n  cursor: pointer;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.form-row.checkboxes {\n  display: flex;\n  gap: 20px;\n}\n\n.form-row.checkboxes label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #b9bbbe;\n  cursor: pointer;\n}\n\n.form-row.checkboxes input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Media Selector */\n.media-selector {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n}\n\n.media-select-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: #b9bbbe;\n}\n\n.media-select-item:hover {\n  background: #40444b;\n}\n\n.media-select-item.selected {\n  background: #5865f2;\n  color: #fff;\n}\n\n.media-select-item .check {\n  width: 20px;\n  font-weight: bold;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 20px;\n  border-top: 1px solid #40444b;\n  margin-top: 10px;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .media-page {\n    padding: 15px;\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filters {\n    flex-direction: column;\n  }\n\n  .filters input,\n  .filters select {\n    width: 100%;\n    max-width: none;\n  }\n\n  .media-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .collections-list {\n    grid-template-columns: 1fr;\n  }\n\n  .categories-list {\n    grid-template-columns: 1fr;\n  }\n\n  .tabs {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
